/* @flow */
import AuthActions from 'auth/AuthActions';
import BirthdateModal from './BirthdateModal.jsx';
import CurrentUser from 'auth/CurrentUser';
import UserActions from 'user/UserActions';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import jwt from 'lib/jsonwebtoken';
import React from 'react';
import waitForPromises from 'lib/waitForPromises.jsx';

const GetBirthdateForChat = React.createClass({
  mixins: [
    linkStateWithStores([CurrentUser]),
  ],

  statics: {
    routePrefetch: [
      params => {
        AuthActions.jwtTokenSignIn(params.token);
        return UserActions.loadCurrentUser(params.token);
      },
    ],
  },

  getInitialState() {
    return this.getStateFromStores();
  },

  getStateFromStores() {
    const token = CurrentUser.getToken();
    if (!token) {
      throw new Error('missing user token');
    }
    const payload = jwt.decode(token);
    const receiver = CurrentUser.getUser();
    return {
      receiver,
      // $FlowFixMe
      senderSignature: payload.sender.signature,
    };
  },

  render() {
    return (
      <div className="ReportChatView">
        <div className="ReportChatView-wrap">
          <BirthdateModal
            user={this.state.receiver}
            senderSignature={this.state.senderSignature}
          />
        </div>
      </div>
    );
  },
});

export default waitForPromises(GetBirthdateForChat);



// WEBPACK FOOTER //
// ./src/chat/components/GetBirthdateForChat.jsx